import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { AuthService } from 'src/app/_core/providers/auth.service';

@Component({
    selector: 'app-person',
    templateUrl: './person.component.html',
    styleUrls: ['./person.component.scss'],
    standalone: false
})
export class PersonComponent implements OnInit {

  // Parameters
  @Input() name: string;
  @Input() email: string;

  // Properties
  public photo: any = "/assets/images/user.png";

  constructor(private readonly _authService: AuthService) { }

  ngOnInit(): void {
    this._loadData()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('email' in changes && changes['email'].currentValue) {
      this._loadData()
    }
  }

  // Public methods
  mailTo() {
      if (this.email === "")
          {return;}

      window.location.href = `mailto:${  this.email}`;
  }
  

  // Private methods
  private _loadData() {
    this._authService.getUserPhoto(this.email).subscribe(
      photoResult => {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
            if (reader && reader.result) {
                this.photo = reader.result;
            } else {
                this.photo = "/assets/images/user.png";
            }
        }, false);

        if (photoResult) {
            reader.readAsDataURL(photoResult);
        }
    },
    error => {
      this.photo = "/assets/images/user.png";
    });
  }

}
